import React from 'react';
import { FadeIn } from './FadeIn';
import { Activity, Brain, ShieldCheck } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="w-full bg-slate-900 py-20 md:py-28 px-6 text-white relative overflow-hidden" data-id="element-176">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-177">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-sage-dark/10 blur-[100px]" data-id="element-178"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-amber/10 blur-[100px]" data-id="element-179"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-180">
        <FadeIn data-id="element-181">
          <div className="text-center mb-16" data-id="element-182">
            <span className="text-amber font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-183">
              El Secreto Biológico
            </span>
            <h2 className="text-3xl md:text-5xl font-serif text-white mb-6" data-id="element-184">
              El Protocolo 5-5-5 <br data-id="element-185" />
              <span className="text-sage-light opacity-90 text-2xl md:text-3xl" data-id="element-186">
                (Interrupción de Adrenalina)
              </span>
            </h2>
          </div>
        </FadeIn>

        <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 p-8 md:p-12 rounded-3xl" data-id="element-187">
          <FadeIn delay={0.2} data-id="element-188">
            <p className="text-xl md:text-2xl text-slate-200 leading-relaxed mb-10 text-center font-serif" data-id="element-189">
              A diferencia de la psicología tradicional, este método no intenta
              "hablar" con el miedo.
            </p>
          </FadeIn>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-190">
            <FadeIn delay={0.3} className="flex flex-col items-center text-center" data-id="element-191">
              <div className="w-16 h-16 bg-slate-700 rounded-2xl flex items-center justify-center mb-6 shadow-inner" data-id="element-192">
                <Activity className="w-8 h-8 text-sage" data-id="element-193" />
              </div>
              <h3 className="text-lg font-bold text-white mb-3" data-id="element-194">
                Ritmos Biológicos
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-195">
                Utiliza ritmos biológicos específicos para forzar al sistema
                nervioso a desactivar la ráfaga de cortisol y adrenalina.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} className="flex flex-col items-center text-center" data-id="element-196">
              <div className="w-16 h-16 bg-slate-700 rounded-2xl flex items-center justify-center mb-6 shadow-inner" data-id="element-197">
                <Brain className="w-8 h-8 text-amber" data-id="element-198" />
              </div>
              <h3 className="text-lg font-bold text-white mb-3" data-id="element-199">
                Comando Directo
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-200">
                Es un comando directo al nervio vago que le dice al cuerpo: "El
                peligro ha pasado".
              </p>
            </FadeIn>

            <FadeIn delay={0.5} className="flex flex-col items-center text-center" data-id="element-201">
              <div className="w-16 h-16 bg-slate-700 rounded-2xl flex items-center justify-center mb-6 shadow-inner" data-id="element-202">
                <ShieldCheck className="w-8 h-8 text-sage" data-id="element-203" />
              </div>
              <h3 className="text-lg font-bold text-white mb-3" data-id="element-204">
                Relajación Inmediata
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-205">
                Logrando una relajación muscular y respiratoria inmediata, sin
                necesidad de razonar.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}